import { html } from 'lit';
// https://icons.getbootstrap.com/
export const draw = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-pencil"
  viewBox="0 0 16 16"
>
  <path
    d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
  />
</svg>`;
export const trash = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_293_475" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_293_475)">
    <path
      d="M23.3333 70C21.5 70 19.9305 69.3472 18.625 68.0417C17.3194 66.7361 16.6666 65.1667 16.6666 63.3333V20H13.3333V13.3333H30V10H50V13.3333H66.6666V20H63.3333V63.3333C63.3333 65.1667 62.6805 66.7361 61.375 68.0417C60.0694 69.3472 58.5 70 56.6666 70H23.3333ZM56.6666 20H23.3333V63.3333H56.6666V20ZM30 56.6667H36.6666V26.6667H30V56.6667ZM43.3333 56.6667H50V26.6667H43.3333V56.6667Z"
      fill="#737373"
    />
  </g>
</svg>`;
export const download = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-download"
  viewBox="0 0 16 16"
>
  <path
    d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
  />
  <path
    d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
  />
</svg>`;
export const group = html `<svg
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g id="Property 1=Group" clip-path="url(#clip0_389_521)">
    <path id="Outside" d="M72 66V14M66 7.5H14M8 14V66M14.5 73H66" stroke="#737373" stroke-width="6" />
    <g id="square">
      <mask id="path-2-inside-1_389_521" fill="white">
        <path d="M0 0H16V16H0V0Z" />
        <path d="M64 0H80V16H64V0Z" />
        <path d="M64 64H80V80H64V64Z" />
        <path d="M0 64H16V80H0V64Z" />
      </mask>
      <path d="M0 0H16V16H0V0Z" stroke="#737373" stroke-width="8" mask="url(#path-2-inside-1_389_521)" />
      <path d="M64 0H80V16H64V0Z" stroke="#737373" stroke-width="8" mask="url(#path-2-inside-1_389_521)" />
      <path d="M64 64H80V80H64V64Z" stroke="#737373" stroke-width="8" mask="url(#path-2-inside-1_389_521)" />
      <path d="M0 64H16V80H0V64Z" stroke="#737373" stroke-width="8" mask="url(#path-2-inside-1_389_521)" />
    </g>
    <g id="Rectangle 63">
      <mask id="path-3-inside-2_389_521" fill="white">
        <rect x="15" y="21" width="50" height="24" rx="4" />
      </mask>
      <rect
        x="15"
        y="21"
        width="50"
        height="24"
        rx="4"
        stroke="#737373"
        stroke-width="12"
        mask="url(#path-3-inside-2_389_521)"
      />
    </g>
    <g id="Rectangle 64">
      <mask id="path-4-inside-3_389_521" fill="white">
        <rect x="15" y="44" width="50" height="16" rx="4" />
      </mask>
      <rect
        x="15"
        y="44"
        width="50"
        height="16"
        rx="4"
        stroke="#737373"
        stroke-width="12"
        mask="url(#path-4-inside-3_389_521)"
      />
    </g>
  </g>
  <defs>
    <clipPath id="clip0_389_521">
      <rect width="80" height="80" fill="white" />
    </clipPath>
  </defs>
</svg> `;
export const ungroup = html `<svg
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="path-1-inside-1_389_522" fill="white">
    <rect x="9" y="15" width="62" height="30" rx="4" />
  </mask>
  <rect
    x="9"
    y="15"
    width="62"
    height="30"
    rx="4"
    stroke="#737373"
    stroke-width="12"
    mask="url(#path-1-inside-1_389_522)"
  />
  <mask id="path-2-inside-2_389_522" fill="white">
    <rect x="9" y="52" width="62" height="20" rx="4" />
  </mask>
  <rect
    x="9"
    y="52"
    width="62"
    height="20"
    rx="4"
    stroke="#737373"
    stroke-width="12"
    mask="url(#path-2-inside-2_389_522)"
  />
</svg> `;
const text = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-fonts"
  viewBox="0 0 16 16"
>
  <path
    d="M12.258 3h-8.51l-.083 2.46h.479c.26-1.544.758-1.783 2.693-1.845l.424-.013v7.827c0 .663-.144.82-1.3.923v.52h4.082v-.52c-1.162-.103-1.306-.26-1.306-.923V3.602l.431.013c1.934.062 2.434.301 2.693 1.846h.479L12.258 3z"
  />
</svg>`;
const back = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-skip-backward"
  viewBox="0 0 16 16"
>
  <path
    d="M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z"
  />
</svg>`;
const forward = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-skip-forward"
  viewBox="0 0 16 16"
>
  <path
    d="M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.752l-6.267 3.636c-.52.302-1.233-.043-1.233-.696v-2.94l-6.267 3.636C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696L7.5 7.248v-2.94c0-.653.713-.998 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5zM1 4.633v6.734L6.804 8 1 4.633zm7.5 0v6.734L14.304 8 8.5 4.633z"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/x-circle/
export const xCircleIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  id="x-circle-icon"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-x-circle"
  viewBox="0 0 16 16"
>
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
  <path
    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/arrows-move/
export const moveIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  id="move-icon"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-arrows-move"
  viewBox="0 0 16 16"
>
  <path
    fill-rule="evenodd"
    d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10zM.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708l-2-2zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8z"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/arrow-up/
export const upArrowIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-arrow-up"
  viewBox="0 0 16 16"
>
  <path
    fill-rule="evenodd"
    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/arrow-down/
export const downArrowIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-arrow-down"
  viewBox="0 0 16 16"
>
  <path
    fill-rule="evenodd"
    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
  />
</svg>`;
// https://icons.getbootstrap.com/icons/save/
export const save = html `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
  <mask id="mask0_281_509" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_281_509)">
    <path
      d="M13.3333 66.6668C11.5 66.6668 9.93052 66.0141 8.62496 64.7085C7.3194 63.4029 6.66663 61.8335 6.66663 60.0002V20.0002C6.66663 18.1668 7.3194 16.5974 8.62496 15.2918C9.93052 13.9863 11.5 13.3335 13.3333 13.3335H30V20.0002H13.3333V60.0002H66.6666V20.0002H50V13.3335H66.6666C68.5 13.3335 70.0694 13.9863 71.375 15.2918C72.6805 16.5974 73.3333 18.1668 73.3333 20.0002V60.0002C73.3333 61.8335 72.6805 63.4029 71.375 64.7085C70.0694 66.0141 68.5 66.6668 66.6666 66.6668H13.3333ZM40 51.3335L23.3333 34.6668L28 30.0002L36.6666 38.6668V13.3335H43.3333V38.6668L52 30.0002L56.6666 34.6668L40 51.3335Z"
      fill="#737373"
    />
  </g>
</svg>`;
const add = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-plus-square"
  viewBox="0 0 16 16"
>
  <path
    d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
  />
  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
</svg>`;
const addImageIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-image"
  viewBox="0 0 16 16"
>
  <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
  <path
    d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"
  />
</svg>`;
export const unlockedIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-unlock"
  viewBox="0 0 16 16"
>
  <path
    d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2zM3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3z"
  />
</svg>`;
export const lockedIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  fill="currentColor"
  class="bi bi-lock"
  viewBox="0 0 16 16"
>
  <path
    d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"
  />
</svg>`;
export default {
    add,
    addImageIcon,
    back,
    download,
    draw,
    forward,
    group,
    text,
    trash,
    save,
    ungroup,
    unlocked: unlockedIcon,
    locked: lockedIcon,
    move: moveIcon,
    cancel: xCircleIcon,
};
// The following SVGs are from Tyler's prototype --------------------------------
//---- Here are all of the drawing tool icons
// drawing tool
export const drawTool = html `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
  <mask id="mask0_29_45" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_45)">
    <path
      d="M40.8333 36.0833L43.9167 39.1667L62 21.0833L58.9167 18L40.8333 36.0833ZM16.6667 63.3333H19.75L39.1667 43.9167L36.0833 40.8333L16.6667 60.25V63.3333ZM46.25 46.25L33.75 33.75L47.6667 19.8333L45.25 17.4167L27 35.6667L22.3333 31L40.5 12.75C41.8333 11.4167 43.4028 10.75 45.2083 10.75C47.0139 10.75 48.5833 11.4167 49.9167 12.75L52.3333 15.1667L56.5 11C57.1667 10.3333 57.9583 10 58.875 10C59.7917 10 60.5833 10.3333 61.25 11L69 18.75C69.6667 19.4167 70 20.2083 70 21.125C70 22.0417 69.6667 22.8333 69 23.5L46.25 46.25ZM22.5 70H10V57.5L33.75 33.75L46.25 46.25L22.5 70Z"
      fill="#737373"
    />
  </g>
</svg>`;
// highlighter
export const highlighter = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_147_4222" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4222)">
    <path
      d="M45.3333 46.6667L36.6667 38L20 54.6667L28.6667 63.3333L45.3333 46.6667ZM41.4167 33.25L50.0833 41.9167L66.6667 25.3333L58 16.6667L41.4167 33.25ZM34.4167 30.9167L52.4167 48.9167L33.3333 68C32 69.3333 30.4444 70 28.6667 70C26.8889 70 25.3333 69.3333 24 68L23.8333 67.8333L21.6667 70H5L15.5 59.5L15.3333 59.3333C14 58 13.3333 56.4444 13.3333 54.6667C13.3333 52.8889 14 51.3333 15.3333 50L34.4167 30.9167ZM34.4167 30.9167L53.3333 12C54.6667 10.6667 56.2222 10 58 10C59.7778 10 61.3333 10.6667 62.6667 12L71.3333 20.6667C72.6667 22 73.3333 23.5556 73.3333 25.3333C73.3333 27.1111 72.6667 28.6667 71.3333 30L52.4167 48.9167L34.4167 30.9167Z"
      fill="#737373"
    />
  </g>
</svg>`;
// eraser
export const eraser = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_147_4225" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4225)">
    <path
      d="M57.4998 60H73.3331V66.6667H50.8331L57.4998 60ZM15.8331 66.6667L8.74975 59.5833C7.47197 58.3056 6.81919 56.7222 6.79141 54.8333C6.76364 52.9444 7.38864 51.3333 8.66641 50L45.3331 12C46.6109 10.6667 48.1803 10 50.0414 10C51.9025 10 53.472 10.6389 54.7498 11.9167L71.3331 28.5C72.6109 29.7778 73.2498 31.3611 73.2498 33.25C73.2498 35.1389 72.6109 36.7222 71.3331 38L43.3331 66.6667H15.8331ZM40.4998 60L66.6664 33.1667L50.1664 16.6667L13.3331 54.6667L18.6664 60H40.4998Z"
      fill="#737373"
    />
  </g>
</svg>`;
//paint bucket
export const paintBucket = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_147_4235" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4235)">
    <path
      d="M28.8332 68.3333L8.33317 47.8333C7.77761 47.2777 7.36095 46.6666 7.08317 46C6.80539 45.3333 6.6665 44.6388 6.6665 43.9166C6.6665 43.1944 6.80539 42.5 7.08317 41.8333C7.36095 41.1666 7.77761 40.5555 8.33317 40L27.4998 20.9166L18.6665 12.0833L23.8332 6.66663L57.1665 40C57.7221 40.5555 58.1248 41.1666 58.3748 41.8333C58.6248 42.5 58.7498 43.1944 58.7498 43.9166C58.7498 44.6388 58.6248 45.3333 58.3748 46C58.1248 46.6666 57.7221 47.2777 57.1665 47.8333L36.6665 68.3333C36.1109 68.8888 35.4998 69.3055 34.8332 69.5833C34.1665 69.8611 33.4721 70 32.7498 70C32.0276 70 31.3332 69.8611 30.6665 69.5833C29.9998 69.3055 29.3887 68.8888 28.8332 68.3333ZM32.7498 26.1666L14.9165 44H50.5832L32.7498 26.1666ZM65.9998 70C63.9998 70 62.3054 69.2916 60.9165 67.875C59.5276 66.4583 58.8332 64.7222 58.8332 62.6666C58.8332 61.1666 59.2082 59.75 59.9582 58.4166C60.7082 57.0833 61.5554 55.7777 62.4998 54.5L65.9998 50L69.6665 54.5C70.5554 55.7777 71.3887 57.0833 72.1665 58.4166C72.9443 59.75 73.3332 61.1666 73.3332 62.6666C73.3332 64.7222 72.6109 66.4583 71.1665 67.875C69.7221 69.2916 67.9998 70 65.9998 70Z"
      fill="#737373"
    />
  </g>
</svg>`;
// ---- here are all my line icons
// straight line
export const straightLine = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="240"
  height="6"
  viewBox="0 0 240 6"
  fill="none"
>
  <path d="M0 3H240" stroke="#737373" stroke-width="5" />
</svg>`;
// single arrow
export const singleArrow = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="243"
  height="38"
  viewBox="0 0 243 38"
  fill="none"
>
  <path
    d="M241.768 20.7678C242.744 19.7915 242.744 18.2085 241.768 17.2322L225.858 1.32233C224.882 0.34602 223.299 0.34602 222.322 1.32233C221.346 2.29864 221.346 3.88155 222.322 4.85786L236.464 19L222.322 33.1421C221.346 34.1184 221.346 35.7014 222.322 36.6777C223.299 37.654 224.882 37.654 225.858 36.6777L241.768 20.7678ZM0 21.5H240V16.5H0V21.5Z"
    fill="#737373"
  />
</svg>`;
// double arrow
export const doubleArrow = html `<svg
  width="246"
  height="38"
  viewBox="0 0 246 38"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M244.768 20.7678C245.744 19.7915 245.744 18.2085 244.768 17.2322L228.858 1.32233C227.882 0.34602 226.299 0.34602 225.322 1.32233C224.346 2.29864 224.346 3.88155 225.322 4.85786L239.464 19L225.322 33.1421C224.346 34.1184 224.346 35.7014 225.322 36.6777C226.299 37.654 227.882 37.654 228.858 36.6777L244.768 20.7678ZM3 21.5H243V16.5H3V21.5Z"
    fill="#737373"
  />
  <path
    d="M1.23222 17.2322C0.255907 18.2085 0.255907 19.7915 1.23222 20.7678L17.1421 36.6777C18.1184 37.654 19.7013 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53552 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7013 0.34602 18.1184 0.34602 17.1421 1.32233L1.23222 17.2322ZM243 16.5L2.99998 16.5V21.5L243 21.5V16.5Z"
    fill="#737373"
  />
</svg>`;
// ---- here are all of the text icons
// text tool
export const textTool = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="68"
  height="54"
  viewBox="0 0 68 54"
  fill="none"
>
  <path
    d="M40.6665 53.6666V10.3333H23.9998V0.333313H67.3332V10.3333H50.6665V53.6666H40.6665ZM10.6665 53.6666V27H0.666504V17H30.6665V27H20.6665V53.6666H10.6665Z"
    fill="#737373"
  />
</svg>`;
// bold
export const bold = html `<svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
  <mask id="mask0_147_4369" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="40">
    <rect x="0.5" width="40" height="40" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4369)">
    <path
      d="M11.8335 31.6666V8.33325H21.0418C22.8474 8.33325 24.5141 8.88881 26.0418 9.99992C27.5696 11.111 28.3335 12.6527 28.3335 14.6249C28.3335 16.0416 28.0141 17.1319 27.3752 17.8958C26.7363 18.6596 26.1391 19.2083 25.5835 19.5416C26.2779 19.8471 27.0488 20.4166 27.896 21.2499C28.7432 22.0833 29.1668 23.3333 29.1668 24.9999C29.1668 27.4721 28.2641 29.2013 26.4585 30.1874C24.6529 31.1735 22.9585 31.6666 21.3752 31.6666H11.8335ZM16.8752 26.9999H21.2085C22.5418 26.9999 23.3543 26.6596 23.646 25.9791C23.9377 25.2985 24.0835 24.8055 24.0835 24.4999C24.0835 24.1944 23.9377 23.7013 23.646 23.0208C23.3543 22.3402 22.5002 21.9999 21.0835 21.9999H16.8752V26.9999ZM16.8752 17.4999H20.7502C21.6668 17.4999 22.3335 17.2638 22.7502 16.7916C23.1668 16.3194 23.3752 15.7916 23.3752 15.2083C23.3752 14.5416 23.1391 13.9999 22.6668 13.5833C22.1946 13.1666 21.5835 12.9583 20.8335 12.9583H16.8752V17.4999Z"
      fill="#737373"
    />
  </g>
</svg>`;
//italic
export const italic = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="41"
  height="40"
  viewBox="0 0 41 40"
  fill="none"
>
  <mask id="mask0_147_4372" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="40">
    <rect x="0.5" width="40" height="40" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4372)">
    <path
      d="M8.83325 31.6666V27.4999H15.4999L20.4999 12.4999H13.8333V8.33325H30.4999V12.4999H24.6666L19.6666 27.4999H25.4999V31.6666H8.83325Z"
      fill="#737373"
    />
  </g>
</svg>`;
//underline
export const underline = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="41"
  height="40"
  viewBox="0 0 41 40"
  fill="none"
>
  <mask id="mask0_147_4375" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="40">
    <rect x="0.5" width="40" height="40" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4375)">
    <path
      d="M8.83325 35V31.6667H32.1666V35H8.83325ZM20.4999 28.3333C17.6944 28.3333 15.5138 27.4583 13.9583 25.7083C12.4027 23.9583 11.6249 21.6389 11.6249 18.75V5H15.9166V19C15.9166 20.5556 16.3055 21.8194 17.0833 22.7917C17.861 23.7639 18.9999 24.25 20.4999 24.25C21.9999 24.25 23.1388 23.7639 23.9166 22.7917C24.6944 21.8194 25.0833 20.5556 25.0833 19V5H29.3749V18.75C29.3749 21.6389 28.5971 23.9583 27.0416 25.7083C25.486 27.4583 23.3055 28.3333 20.4999 28.3333Z"
      fill="#737373"
    />
  </g>
</svg>`;
//strikethrough
export const strikethrough = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="41"
  height="40"
  viewBox="0 0 41 40"
  fill="none"
>
  <mask id="mask0_147_4378" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="40">
    <rect x="0.5" width="40" height="40" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4378)">
    <path
      d="M3.83325 23.3334V20.0001H37.1666V23.3334H3.83325ZM17.9999 16.6667V11.6667H8.83325V6.66675H32.1666V11.6667H22.9999V16.6667H17.9999ZM17.9999 33.3334V26.6667H22.9999V33.3334H17.9999Z"
      fill="#737373"
    />
  </g>
</svg>`;
//text align left
export const textAlignLeft = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
>
  <mask id="mask0_147_4679" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
    <rect width="40" height="40" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4679)">
    <path
      d="M5 35V31.6667H35V35H5ZM5 28.3333V25H25V28.3333H5ZM5 21.6667V18.3333H35V21.6667H5ZM5 15V11.6667H25V15H5ZM5 8.33333V5H35V8.33333H5Z"
      fill="#737373"
    />
  </g>
</svg>`;
//text align right
export const textAlignRight = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
>
  <mask id="mask0_147_4685" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
    <rect width="40" height="40" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4685)">
    <path
      d="M5 8.33333V5H35V8.33333H5ZM15 15V11.6667H35V15H15ZM5 21.6667V18.3333H35V21.6667H5ZM15 28.3333V25H35V28.3333H15ZM5 35V31.6667H35V35H5Z"
      fill="#737373"
    />
  </g>
</svg>`;
//text align center
export const textAlignCenter = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
>
  <mask id="mask0_147_4692" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
    <rect width="40" height="40" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_147_4692)">
    <path
      d="M5 35V31.6667H35V35H5ZM11.6667 28.3333V25H28.3333V28.3333H11.6667ZM5 21.6667V18.3333H35V21.6667H5ZM11.6667 15V11.6667H28.3333V15H11.6667ZM5 8.33333V5H35V8.33333H5Z"
      fill="#737373"
    />
  </g>
</svg>`;
// ---- Here are all the shape mode icons
// shape mode
export const shapeMode = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_29_53" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_53)">
    <path
      d="M26.6665 59.8333C27.2221 59.8888 27.7637 59.9305 28.2915 59.9583C28.8193 59.9861 29.3887 60 29.9998 60C30.6109 60 31.1804 59.9861 31.7082 59.9583C32.236 59.9305 32.7776 59.8888 33.3332 59.8333V66.6666H66.6665V33.3333H59.8332C59.8887 32.7777 59.9304 32.2361 59.9582 31.7083C59.986 31.1805 59.9998 30.6111 59.9998 30C59.9998 29.3888 59.986 28.8194 59.9582 28.2916C59.9304 27.7638 59.8887 27.2222 59.8332 26.6666H66.6665C68.4998 26.6666 70.0693 27.3194 71.3748 28.625C72.6804 29.9305 73.3332 31.5 73.3332 33.3333V66.6666C73.3332 68.5 72.6804 70.0694 71.3748 71.375C70.0693 72.6805 68.4998 73.3333 66.6665 73.3333H33.3332C31.4998 73.3333 29.9304 72.6805 28.6248 71.375C27.3193 70.0694 26.6665 68.5 26.6665 66.6666V59.8333ZM29.9998 53.3333C23.4998 53.3333 17.9859 51.0694 13.4582 46.5416C8.93039 42.0138 6.6665 36.5 6.6665 30C6.6665 23.5 8.93039 17.9861 13.4582 13.4583C17.9859 8.93052 23.4998 6.66663 29.9998 6.66663C36.4998 6.66663 42.0137 8.93052 46.5415 13.4583C51.0693 17.9861 53.3332 23.5 53.3332 30C53.3332 36.5 51.0693 42.0138 46.5415 46.5416C42.0137 51.0694 36.4998 53.3333 29.9998 53.3333ZM29.9998 46.6666C34.6109 46.6666 38.5415 45.0416 41.7915 41.7916C45.0415 38.5416 46.6665 34.6111 46.6665 30C46.6665 25.3888 45.0415 21.4583 41.7915 18.2083C38.5415 14.9583 34.6109 13.3333 29.9998 13.3333C25.3887 13.3333 21.4582 14.9583 18.2082 18.2083C14.9582 21.4583 13.3332 25.3888 13.3332 30C13.3332 34.6111 14.9582 38.5416 18.2082 41.7916C21.4582 45.0416 25.3887 46.6666 29.9998 46.6666Z"
      fill="#737373"
    />
  </g>
</svg>`;
// ----- Here are all of the shapes
//circle
export const circle = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="54"
  height="54"
  viewBox="0 0 54 54"
  fill="none"
>
  <path
    d="M27 53.6666C23.3111 53.6666 19.8445 52.9666 16.6 51.5666C13.3556 50.1666 10.5334 48.2666 8.13337 45.8666C5.73337 43.4666 3.83337 40.6444 2.43337 37.3999C1.03337 34.1555 0.333374 30.6888 0.333374 26.9999C0.333374 23.311 1.03337 19.8444 2.43337 16.5999C3.83337 13.3555 5.73337 10.5333 8.13337 8.13325C10.5334 5.73325 13.3556 3.83325 16.6 2.43325C19.8445 1.03325 23.3111 0.333252 27 0.333252C30.6889 0.333252 34.1556 1.03325 37.4 2.43325C40.6445 3.83325 43.4667 5.73325 45.8667 8.13325C48.2667 10.5333 50.1667 13.3555 51.5667 16.5999C52.9667 19.8444 53.6667 23.311 53.6667 26.9999C53.6667 30.6888 52.9667 34.1555 51.5667 37.3999C50.1667 40.6444 48.2667 43.4666 45.8667 45.8666C43.4667 48.2666 40.6445 50.1666 37.4 51.5666C34.1556 52.9666 30.6889 53.6666 27 53.6666ZM27 48.3332C32.9556 48.3332 38 46.2666 42.1334 42.1333C46.2667 37.9999 48.3334 32.9555 48.3334 26.9999C48.3334 21.0444 46.2667 15.9999 42.1334 11.8666C38 7.73325 32.9556 5.66658 27 5.66658C21.0445 5.66658 16 7.73325 11.8667 11.8666C7.73337 15.9999 5.66671 21.0444 5.66671 26.9999C5.66671 32.9555 7.73337 37.9999 11.8667 42.1333C16 46.2666 21.0445 48.3332 27 48.3332Z"
    fill="#737373"
  />
</svg>`;
//square
export const square = html `<svg
  width="48"
  height="48"
  viewBox="0 0 48 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="path-1-inside-1_128_991" fill="white">
    <rect width="48" height="48" rx="4" />
  </mask>
  <rect width="48" height="48" rx="4" stroke="#737373" stroke-width="10" mask="url(#path-1-inside-1_128_991)" />
</svg> `;
//triangle
export const triangle = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="64"
  height="64"
  viewBox="0 0 64 64"
  fill="none"
>
  <mask id="mask0_128_954" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
    <rect width="64" height="64" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_128_954)">
    <path
      d="M7.13762 53.3334C6.35219 53.3334 5.87334 52.4695 6.28962 51.8034L31.152 12.0235C31.5437 11.3969 32.4564 11.3969 32.848 12.0235L57.7105 51.8034C58.1267 52.4695 57.6479 53.3334 56.8625 53.3334H7.13762ZM15.8885 46.4705C15.4726 47.1365 15.9514 48.0001 16.7367 48.0001H47.2634C48.0486 48.0001 48.5275 47.1365 48.1116 46.4705L32.8483 22.0252C32.4567 21.3981 31.5434 21.3981 31.1518 22.0252L15.8885 46.4705Z"
      fill="#737373"
    />
  </g>
</svg>`;
//rectangle
export const rectangle = html `<svg
  width="73"
  height="48"
  viewBox="0 0 73 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="2.25" y="2" width="68" height="44" rx="2" stroke="#737373" stroke-width="4" />
</svg> `;
//trapezoid
export const trapezoid = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="75"
  height="38"
  viewBox="0 0 75 38"
  fill="none"
>
  <path
    d="M68.7779 35.5H6.72214C3.74861 35.5 1.81462 32.3708 3.14443 29.7111L15.6444 4.71115C16.322 3.35601 17.707 2.5 19.2221 2.5H56.2779C57.793 2.5 59.178 3.35601 59.8556 4.71115L72.3556 29.7111C73.6854 32.3708 71.7514 35.5 68.7779 35.5Z"
    stroke="#737373"
    stroke-width="4"
  />
</svg>`;
//hexagon
export const hexagon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="55"
  height="48"
  viewBox="0 0 55 48"
  fill="none"
>
  <path
    d="M16.18 48C14.7514 48 13.4312 47.2381 12.7165 46.0011L1.16096 26.0011C0.445571 24.7629 0.445572 23.2371 1.16096 21.9989L12.7165 1.99889C13.4312 0.761909 14.7514 0 16.18 0H39.2962C40.7248 0 42.045 0.761911 42.7597 1.99889L54.3152 21.9989C55.0306 23.2371 55.0306 24.7629 54.3152 26.0011L42.7597 46.0011C42.045 47.2381 40.7248 48 39.2962 48H16.18ZM15.7828 40.6698C16.4978 41.9057 17.8173 42.6667 19.2451 42.6667H36.224C37.6556 42.6667 38.978 41.9016 39.6916 40.6606L48.1249 25.9939C48.8348 24.7594 48.8348 23.2406 48.1249 22.0061L39.6916 7.33945C38.978 6.0984 37.6556 5.33333 36.224 5.33333H19.2451C17.8173 5.33333 16.4978 6.09435 15.7828 7.33016L7.29707 21.9968C6.5801 23.236 6.5801 24.764 7.29707 26.0032L15.7828 40.6698Z"
    fill="#737373"
  />
</svg>`;
//star
export const star = html `<svg xmlns="http://www.w3.org/2000/svg" width="65" height="64" viewBox="0 0 65 64" fill="none">
  <mask id="mask0_128_1054" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="65" height="64">
    <rect x="0.737793" width="64" height="64" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_128_1054)">
    <path
      d="M24.3378 47.5333L32.7378 42.4667L41.1378 47.6L38.9378 38L46.3378 31.6L36.6045 30.7333L32.7378 21.6667L28.8712 30.6667L19.1378 31.5333L26.5378 38L24.3378 47.5333ZM16.2712 58.6667L20.6045 39.9333L6.07117 27.3333L25.2712 25.6667L32.7378 8L40.2045 25.6667L59.4045 27.3333L44.8712 39.9333L49.2045 58.6667L32.7378 48.7333L16.2712 58.6667Z"
      fill="#737373"
    />
  </g>
</svg>`;
//Thought bubble
export const thoughtBubble = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="76"
  height="55"
  viewBox="0 0 76 55"
  fill="none"
>
  <path
    d="M65.75 41.0356H30.25L16.25 49.5356L19.75 41.0356H11.25C4.05005 41.0356 2.58338 37.369 2.75005 35.5356V12.5356C3.15005 4.13564 7.58338 2.36896 9.75005 2.53562H64.75C71.9501 1.73562 73.4167 7.86895 73.2501 11.0356V33.0356C72.4501 40.2356 67.9167 41.3689 65.75 41.0356Z"
    stroke="#737373"
    stroke-width="4"
  />
</svg>`;
//rhombus
export const rhombus = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="63"
  height="38"
  viewBox="0 0 63 38"
  fill="none"
>
  <path
    d="M37.744 35.75H6.13096C2.85693 35.75 0.969555 32.0314 2.90227 29.3887L21.5515 3.88873C22.3048 2.85878 23.5042 2.25 24.7802 2.25H56.7739C60.0656 2.25 61.9484 6.00419 59.9796 8.64233L40.9497 34.1423C40.1947 35.1541 39.0064 35.75 37.744 35.75Z"
    stroke="#737373"
    stroke-width="4"
  />
</svg>`;
// ---- here are the utility icons
// image add
export const imageAdd = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_29_90" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_90)">
    <path
      d="M16.6667 70C14.8333 70 13.2639 69.3472 11.9583 68.0417C10.6528 66.7361 10 65.1667 10 63.3333V16.6667C10 14.8333 10.6528 13.2639 11.9583 11.9583C13.2639 10.6528 14.8333 10 16.6667 10H46.6667V16.6667H16.6667V63.3333H63.3333V33.3333H70V63.3333C70 65.1667 69.3472 66.7361 68.0417 68.0417C66.7361 69.3472 65.1667 70 63.3333 70H16.6667ZM56.6667 30V23.3333H50V16.6667H56.6667V10H63.3333V16.6667H70V23.3333H63.3333V30H56.6667ZM20 56.6667H60L47.5 40L37.5 53.3333L30 43.3333L20 56.6667Z"
      fill="#737373"
    />
  </g>
</svg>`;
//increase size (I think that's what this icon is for)
export const increaseSize = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_29_93" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_93)">
    <path
      d="M40 73.3333L20 53.3333L24.75 48.5833L40 63.8333L55.25 48.5833L60 53.3333L40 73.3333ZM24.8333 31.3333L20 26.6666L40 6.66663L60 26.6666L55.1667 31.3333L40 16.1666L24.8333 31.3333Z"
      fill="#454545"
    />
  </g>
</svg>`;
// decrease size (I think that's what this icon is for)
export const decreaseSize = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_29_96" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_96)">
    <path
      d="M24.6667 73.3333L20 68.6666L40 48.6666L60 68.6666L55.3333 73.3333L40 58L24.6667 73.3333ZM40 31.3333L20 11.3333L24.6667 6.66663L40 22L55.3333 6.66663L60 11.3333L40 31.3333Z"
      fill="#454545"
    />
  </g>
</svg>`;
// Download card
export const downloadCard = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_29_99" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_99)">
    <path
      d="M13.3332 66.6667C11.4998 66.6667 9.93039 66.0139 8.62484 64.7084C7.31928 63.4028 6.6665 61.8334 6.6665 60V20C6.6665 18.1667 7.31928 16.5973 8.62484 15.2917C9.93039 13.9862 11.4998 13.3334 13.3332 13.3334H29.9998V20H13.3332V60H66.6665V20H49.9998V13.3334H66.6665C68.4998 13.3334 70.0693 13.9862 71.3748 15.2917C72.6804 16.5973 73.3332 18.1667 73.3332 20V60C73.3332 61.8334 72.6804 63.4028 71.3748 64.7084C70.0693 66.0139 68.4998 66.6667 66.6665 66.6667H13.3332ZM39.9998 51.3334L23.3332 34.6667L27.9998 30L36.6665 38.6667V13.3334H43.3332V38.6667L51.9998 30L56.6665 34.6667L39.9998 51.3334Z"
      fill="#737373"
    />
  </g>
</svg>`;
// Add new card
export const addNewCard = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_29_102" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_102)">
    <path
      d="M36.6667 56.6667H43.3333V43.3333H56.6667V36.6667H43.3333V23.3333H36.6667V36.6667H23.3333V43.3333H36.6667V56.6667ZM16.6667 70C14.8333 70 13.2639 69.3472 11.9583 68.0417C10.6528 66.7361 10 65.1667 10 63.3333V16.6667C10 14.8333 10.6528 13.2639 11.9583 11.9583C13.2639 10.6528 14.8333 10 16.6667 10H63.3333C65.1667 10 66.7361 10.6528 68.0417 11.9583C69.3472 13.2639 70 14.8333 70 16.6667V63.3333C70 65.1667 69.3472 66.7361 68.0417 68.0417C66.7361 69.3472 65.1667 70 63.3333 70H16.6667ZM16.6667 63.3333H63.3333V16.6667H16.6667V63.3333Z"
      fill="#737373"
    />
  </g>
</svg>`;
// undo action
export const undoAction = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_29_128" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_128)">
    <path
      d="M18.3335 60V20H25.0002V60H18.3335ZM61.6668 60L31.6668 40L61.6668 20V60ZM55.0002 47.5V32.5L43.6668 40L55.0002 47.5Z"
      fill="#454545"
    />
  </g>
</svg>`;
// redo action
export const redoAction = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_29_122" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_122)">
    <path
      d="M55.0002 60V20H61.6668V60H55.0002ZM18.3335 60V20L48.3335 40L18.3335 60ZM25.0002 47.5L36.3335 40L25.0002 32.5V47.5Z"
      fill="#454545"
    />
  </g>
</svg>`;
// delete object
export const deleteObject = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="80"
  height="80"
  viewBox="0 0 80 80"
  fill="none"
>
  <mask id="mask0_29_114" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
    <rect width="80" height="80" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_114)">
    <path
      d="M23.3333 70C21.4999 70 19.9305 69.3472 18.6249 68.0417C17.3194 66.7361 16.6666 65.1667 16.6666 63.3333V20H13.3333V13.3333H29.9999V10H49.9999V13.3333H66.6666V20H63.3333V63.3333C63.3333 65.1667 62.6805 66.7361 61.3749 68.0417C60.0694 69.3472 58.4999 70 56.6666 70H23.3333ZM56.6666 20H23.3333V63.3333H56.6666V20ZM29.9999 56.6667H36.6666V26.6667H29.9999V56.6667ZM43.3333 56.6667H49.9999V26.6667H43.3333V56.6667Z"
      fill="#454545"
    />
  </g>
</svg>`;
// Drag indicator
export const dragIndicator = html ` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="48"
  height="48"
  viewBox="0 0 48 48"
  fill="none"
>
  <mask id="mask0_29_227" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
    <rect width="48" height="48" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_29_227)">
    <path
      d="M18 40C16.9 40 15.9583 39.6083 15.175 38.825C14.3917 38.0417 14 37.1 14 36C14 34.9 14.3917 33.9583 15.175 33.175C15.9583 32.3917 16.9 32 18 32C19.1 32 20.0417 32.3917 20.825 33.175C21.6083 33.9583 22 34.9 22 36C22 37.1 21.6083 38.0417 20.825 38.825C20.0417 39.6083 19.1 40 18 40ZM30 40C28.9 40 27.9583 39.6083 27.175 38.825C26.3917 38.0417 26 37.1 26 36C26 34.9 26.3917 33.9583 27.175 33.175C27.9583 32.3917 28.9 32 30 32C31.1 32 32.0417 32.3917 32.825 33.175C33.6083 33.9583 34 34.9 34 36C34 37.1 33.6083 38.0417 32.825 38.825C32.0417 39.6083 31.1 40 30 40ZM18 28C16.9 28 15.9583 27.6083 15.175 26.825C14.3917 26.0417 14 25.1 14 24C14 22.9 14.3917 21.9583 15.175 21.175C15.9583 20.3917 16.9 20 18 20C19.1 20 20.0417 20.3917 20.825 21.175C21.6083 21.9583 22 22.9 22 24C22 25.1 21.6083 26.0417 20.825 26.825C20.0417 27.6083 19.1 28 18 28ZM30 28C28.9 28 27.9583 27.6083 27.175 26.825C26.3917 26.0417 26 25.1 26 24C26 22.9 26.3917 21.9583 27.175 21.175C27.9583 20.3917 28.9 20 30 20C31.1 20 32.0417 20.3917 32.825 21.175C33.6083 21.9583 34 22.9 34 24C34 25.1 33.6083 26.0417 32.825 26.825C32.0417 27.6083 31.1 28 30 28ZM18 16C16.9 16 15.9583 15.6083 15.175 14.825C14.3917 14.0417 14 13.1 14 12C14 10.9 14.3917 9.95833 15.175 9.175C15.9583 8.39167 16.9 8 18 8C19.1 8 20.0417 8.39167 20.825 9.175C21.6083 9.95833 22 10.9 22 12C22 13.1 21.6083 14.0417 20.825 14.825C20.0417 15.6083 19.1 16 18 16ZM30 16C28.9 16 27.9583 15.6083 27.175 14.825C26.3917 14.0417 26 13.1 26 12C26 10.9 26.3917 9.95833 27.175 9.175C27.9583 8.39167 28.9 8 30 8C31.1 8 32.0417 8.39167 32.825 9.175C33.6083 9.95833 34 10.9 34 12C34 13.1 33.6083 14.0417 32.825 14.825C32.0417 15.6083 31.1 16 30 16Z"
      fill="#DB8D7E"
    />
  </g>
</svg>`;
// previous slide
export const previousSlide = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask id="mask0_158_479" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect x="24" y="24" width="24" height="24" transform="rotate(-180 24 24)" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_158_479)">
    <path d="M15.975 2L17.75 3.775L9.525 12L17.75 20.225L15.975 22L5.975 12L15.975 2Z" fill="#DB8D7E" />
  </g>
</svg>`;
// next slide
export const nextSlide = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask id="mask0_158_482" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_158_482)">
    <path d="M8.025 22L6.25 20.225L14.475 12L6.25 3.775L8.025 2L18.025 12L8.025 22Z" fill="#DB8D7E" />
  </g>
</svg>`;
// mini map
export const miniMap = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask id="mask0_158_824" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_158_824)">
    <path
      d="M15 21L9 18.9L4.35 20.7C4.01667 20.8333 3.70833 20.7958 3.425 20.5875C3.14167 20.3792 3 20.1 3 19.75V5.75C3 5.53333 3.0625 5.34167 3.1875 5.175C3.3125 5.00833 3.48333 4.88333 3.7 4.8L9 3L15 5.1L19.65 3.3C19.9833 3.16667 20.2917 3.20417 20.575 3.4125C20.8583 3.62083 21 3.9 21 4.25V18.25C21 18.4667 20.9375 18.6583 20.8125 18.825C20.6875 18.9917 20.5167 19.1167 20.3 19.2L15 21ZM14 18.55V6.85L10 5.45V17.15L14 18.55ZM16 18.55L19 17.55V5.7L16 6.85V18.55ZM5 18.3L8 17.15V5.45L5 6.45V18.3Z"
      fill="#737373"
    />
  </g>
</svg>`;
export const minimizeToolbarIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
>
  <mask id="mask0_281_530" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
    <rect width="40" height="40" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_281_530)">
    <path
      d="M11.6666 21.6668H28.3333V18.3335H11.6666V21.6668ZM19.9999 36.6668C17.6944 36.6668 15.5277 36.2293 13.4999 35.3543C11.4721 34.4793 9.70825 33.2918 8.20825 31.7918C6.70825 30.2918 5.52075 28.5279 4.64575 26.5002C3.77075 24.4724 3.33325 22.3057 3.33325 20.0002C3.33325 17.6946 3.77075 15.5279 4.64575 13.5002C5.52075 11.4724 6.70825 9.7085 8.20825 8.2085C9.70825 6.7085 11.4721 5.521 13.4999 4.646C15.5277 3.771 17.6944 3.3335 19.9999 3.3335C22.3055 3.3335 24.4721 3.771 26.4999 4.646C28.5277 5.521 30.2916 6.7085 31.7916 8.2085C33.2916 9.7085 34.4791 11.4724 35.3541 13.5002C36.2291 15.5279 36.6666 17.6946 36.6666 20.0002C36.6666 22.3057 36.2291 24.4724 35.3541 26.5002C34.4791 28.5279 33.2916 30.2918 31.7916 31.7918C30.2916 33.2918 28.5277 34.4793 26.4999 35.3543C24.4721 36.2293 22.3055 36.6668 19.9999 36.6668ZM19.9999 33.3335C23.7221 33.3335 26.8749 32.0418 29.4583 29.4585C32.0416 26.8752 33.3333 23.7224 33.3333 20.0002C33.3333 16.2779 32.0416 13.1252 29.4583 10.5418C26.8749 7.9585 23.7221 6.66683 19.9999 6.66683C16.2777 6.66683 13.1249 7.9585 10.5416 10.5418C7.95825 13.1252 6.66659 16.2779 6.66659 20.0002C6.66659 23.7224 7.95825 26.8752 10.5416 29.4585C13.1249 32.0418 16.2777 33.3335 19.9999 33.3335Z"
      fill="#DB8D7E"
    />
  </g>
</svg>`;
export const historyIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <mask id="mask0_737_1202" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_737_1202)">
    <path
      d="M12 21C9.7 21 7.69583 20.2375 5.9875 18.7125C4.27917 17.1875 3.3 15.2833 3.05 13H5.1C5.33333 14.7333 6.10417 16.1667 7.4125 17.3C8.72083 18.4333 10.25 19 12 19C13.95 19 15.6042 18.3208 16.9625 16.9625C18.3208 15.6042 19 13.95 19 12C19 10.05 18.3208 8.39583 16.9625 7.0375C15.6042 5.67917 13.95 5 12 5C10.85 5 9.775 5.26667 8.775 5.8C7.775 6.33333 6.93333 7.06667 6.25 8H9V10H3V4H5V6.35C5.85 5.28333 6.8875 4.45833 8.1125 3.875C9.3375 3.29167 10.6333 3 12 3C13.25 3 14.4208 3.2375 15.5125 3.7125C16.6042 4.1875 17.5542 4.82917 18.3625 5.6375C19.1708 6.44583 19.8125 7.39583 20.2875 8.4875C20.7625 9.57917 21 10.75 21 12C21 13.25 20.7625 14.4208 20.2875 15.5125C19.8125 16.6042 19.1708 17.5542 18.3625 18.3625C17.5542 19.1708 16.6042 19.8125 15.5125 20.2875C14.4208 20.7625 13.25 21 12 21ZM14.8 16.2L11 12.4V7H13V11.6L16.2 14.8L14.8 16.2Z"
    />
  </g>
</svg>`;
export const palleteIcon = html `<svg
  width="25"
  height="25"
  viewBox="0 0 25 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="mask0_1046_1583" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
    <rect x="0.027832" y="0.216797" width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_1046_1583)">
    <path
      d="M12.0278 22.2168C10.6612 22.2168 9.3695 21.9543 8.15283 21.4293C6.93617 20.9043 5.87367 20.1876 4.96533 19.2793C4.057 18.371 3.34033 17.3085 2.81533 16.0918C2.29033 14.8751 2.02783 13.5835 2.02783 12.2168C2.02783 10.8335 2.29867 9.53346 2.84033 8.3168C3.382 7.10013 4.11533 6.0418 5.04033 5.1418C5.96533 4.2418 7.0445 3.5293 8.27783 3.0043C9.51117 2.4793 10.8278 2.2168 12.2278 2.2168C13.5612 2.2168 14.8195 2.44596 16.0028 2.9043C17.1862 3.36263 18.2237 3.99596 19.1153 4.8043C20.007 5.61263 20.7153 6.57096 21.2403 7.6793C21.7653 8.78763 22.0278 9.98346 22.0278 11.2668C22.0278 13.1835 21.4445 14.6543 20.2778 15.6793C19.1112 16.7043 17.6945 17.2168 16.0278 17.2168H14.1778C14.0278 17.2168 13.9237 17.2585 13.8653 17.3418C13.807 17.4251 13.7778 17.5168 13.7778 17.6168C13.7778 17.8168 13.9028 18.1043 14.1528 18.4793C14.4028 18.8543 14.5278 19.2835 14.5278 19.7668C14.5278 20.6001 14.2987 21.2168 13.8403 21.6168C13.382 22.0168 12.7778 22.2168 12.0278 22.2168ZM6.52783 13.2168C6.96117 13.2168 7.3195 13.0751 7.60283 12.7918C7.88617 12.5085 8.02783 12.1501 8.02783 11.7168C8.02783 11.2835 7.88617 10.9251 7.60283 10.6418C7.3195 10.3585 6.96117 10.2168 6.52783 10.2168C6.0945 10.2168 5.73617 10.3585 5.45283 10.6418C5.1695 10.9251 5.02783 11.2835 5.02783 11.7168C5.02783 12.1501 5.1695 12.5085 5.45283 12.7918C5.73617 13.0751 6.0945 13.2168 6.52783 13.2168ZM9.52783 9.2168C9.96117 9.2168 10.3195 9.07513 10.6028 8.7918C10.8862 8.50846 11.0278 8.15013 11.0278 7.7168C11.0278 7.28346 10.8862 6.92513 10.6028 6.6418C10.3195 6.35846 9.96117 6.2168 9.52783 6.2168C9.0945 6.2168 8.73617 6.35846 8.45283 6.6418C8.1695 6.92513 8.02783 7.28346 8.02783 7.7168C8.02783 8.15013 8.1695 8.50846 8.45283 8.7918C8.73617 9.07513 9.0945 9.2168 9.52783 9.2168ZM14.5278 9.2168C14.9612 9.2168 15.3195 9.07513 15.6028 8.7918C15.8862 8.50846 16.0278 8.15013 16.0278 7.7168C16.0278 7.28346 15.8862 6.92513 15.6028 6.6418C15.3195 6.35846 14.9612 6.2168 14.5278 6.2168C14.0945 6.2168 13.7362 6.35846 13.4528 6.6418C13.1695 6.92513 13.0278 7.28346 13.0278 7.7168C13.0278 8.15013 13.1695 8.50846 13.4528 8.7918C13.7362 9.07513 14.0945 9.2168 14.5278 9.2168ZM17.5278 13.2168C17.9612 13.2168 18.3195 13.0751 18.6028 12.7918C18.8862 12.5085 19.0278 12.1501 19.0278 11.7168C19.0278 11.2835 18.8862 10.9251 18.6028 10.6418C18.3195 10.3585 17.9612 10.2168 17.5278 10.2168C17.0945 10.2168 16.7362 10.3585 16.4528 10.6418C16.1695 10.9251 16.0278 11.2835 16.0278 11.7168C16.0278 12.1501 16.1695 12.5085 16.4528 12.7918C16.7362 13.0751 17.0945 13.2168 17.5278 13.2168ZM12.0278 20.2168C12.1778 20.2168 12.2987 20.1751 12.3903 20.0918C12.482 20.0085 12.5278 19.9001 12.5278 19.7668C12.5278 19.5335 12.4028 19.2585 12.1528 18.9418C11.9028 18.6251 11.7778 18.1501 11.7778 17.5168C11.7778 16.8168 12.0195 16.2585 12.5028 15.8418C12.9862 15.4251 13.5778 15.2168 14.2778 15.2168H16.0278C17.1278 15.2168 18.0695 14.896 18.8528 14.2543C19.6362 13.6126 20.0278 12.6168 20.0278 11.2668C20.0278 9.25013 19.257 7.57096 17.7153 6.2293C16.1737 4.88763 14.3445 4.2168 12.2278 4.2168C9.96117 4.2168 8.02783 4.9918 6.42783 6.5418C4.82783 8.0918 4.02783 9.98346 4.02783 12.2168C4.02783 14.4335 4.807 16.321 6.36533 17.8793C7.92367 19.4376 9.81117 20.2168 12.0278 20.2168Z"
    />
  </g>
</svg> `;
export const colorPickerIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="42"
  height="41"
  viewBox="0 0 42 41"
  fill="none"
>
  <g filter="url(#filter0_d_566_1206)">
    <circle cx="21" cy="17" r="13.9091" stroke="#A6A6A6" stroke-width="6.18182" shape-rendering="crispEdges" />
  </g>
  <circle cx="21" cy="17" r="12.3636" stroke="#F2F2F2" stroke-width="6.18182" />
  <defs>
    <filter
      id="filter0_d_566_1206"
      x="0.909091"
      y="0"
      width="40.1818"
      height="40.1818"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="3.09091" />
      <feGaussianBlur stdDeviation="1.54545" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_566_1206" />
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_566_1206" result="shape" />
    </filter>
  </defs>
</svg>`;
export const checkIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="25"
  viewBox="0 0 24 25"
  fill="none"
>
  <mask id="mask0_99_330" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
    <rect y="0.666992" width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_99_330)">
    <path
      d="M9.5501 18.6671L3.8501 12.9671L5.2751 11.5421L9.5501 15.8171L18.7251 6.64209L20.1501 8.06709L9.5501 18.6671Z"
      fill="#DB8D7E"
    />
  </g>
</svg>`;
export const checkIconWhite = html `<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="mask0_1161_1626" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_1161_1626)">
    <path
      d="M9.5501 17.9996L3.8501 12.2996L5.2751 10.8746L9.5501 15.1496L18.7251 5.97461L20.1501 7.39961L9.5501 17.9996Z"
      fill="white"
    />
  </g>
</svg> `;
export const checkIconRaw = `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="25"
  viewBox="0 0 24 25"
  fill="none"
>
  <mask
    id="mask0_99_330"
    style="mask-type:alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="24"
    height="25"
  >
    <rect y="0.666992" width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_99_330)">
    <path
      d="M9.5501 18.6671L3.8501 12.9671L5.2751 11.5421L9.5501 15.8171L18.7251 6.64209L20.1501 8.06709L9.5501 18.6671Z"
      fill="#DB8D7E"
    />
  </g>
</svg>`;
export const savingIcon = html `<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="mask0_1161_1632" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_1161_1632)">
    <path
      d="M5.1 16.05C4.73333 15.4167 4.45833 14.7667 4.275 14.1C4.09167 13.4333 4 12.75 4 12.05C4 9.81667 4.775 7.91667 6.325 6.35C7.875 4.78333 9.76667 4 12 4H12.175L10.575 2.4L11.975 1L15.975 5L11.975 9L10.575 7.6L12.175 6H12C10.3333 6 8.91667 6.5875 7.75 7.7625C6.58333 8.9375 6 10.3667 6 12.05C6 12.4833 6.05 12.9083 6.15 13.325C6.25 13.7417 6.4 14.15 6.6 14.55L5.1 16.05ZM12.025 23L8.025 19L12.025 15L13.425 16.4L11.825 18H12C13.6667 18 15.0833 17.4125 16.25 16.2375C17.4167 15.0625 18 13.6333 18 11.95C18 11.5167 17.95 11.0917 17.85 10.675C17.75 10.2583 17.6 9.85 17.4 9.45L18.9 7.95C19.2667 8.58333 19.5417 9.23333 19.725 9.9C19.9083 10.5667 20 11.25 20 11.95C20 14.1833 19.225 16.0833 17.675 17.65C16.125 19.2167 14.2333 20 12 20H11.825L13.425 21.6L12.025 23Z"
      fill="white"
    />
  </g>
</svg> `;
export const addLinkIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="40"
  height="40"
  fill="none"
  viewBox="0 0 40 40"
>
  <mask id="a" width="40" height="40" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha">
    <path fill="#D9D9D9" d="M0 0h40v40H0z" />
  </mask>
  <g mask="url(#a)">
    <path
      fill="#737373"
      d="m30.392 32.749-4.714 4.714c-1.63 1.63-3.595 2.445-5.893 2.445-2.298 0-4.262-.815-5.892-2.445-1.63-1.63-2.446-3.595-2.446-5.893 0-2.298.815-4.262 2.446-5.892l4.714-4.714 2.357 2.357-4.714 4.714c-.982.982-1.474 2.16-1.474 3.535s.492 2.554 1.474 3.536c.982.982 2.16 1.473 3.535 1.473s2.554-.491 3.536-1.473l4.714-4.714 2.357 2.357Zm-8.25-1.179-2.357-2.357 9.428-9.428 2.357 2.357-9.428 9.428Zm10.607-1.178-2.357-2.357 4.714-4.714c.982-.983 1.473-2.161 1.473-3.536s-.491-2.553-1.473-3.535c-.982-.982-2.16-1.474-3.536-1.474-1.375 0-2.553.492-3.535 1.474l-4.714 4.714-2.357-2.357 4.714-4.714c1.63-1.63 3.594-2.446 5.892-2.446 2.298 0 4.263.815 5.893 2.446 1.63 1.63 2.445 3.594 2.445 5.892 0 2.298-.815 4.262-2.445 5.893l-4.714 4.714ZM11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z"
    />
  </g>
</svg> `;
export const editLinkIcon = html `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="40"
  height="40"
  fill="none"
  viewBox="0 0 40 40"
>
  <mask id="a" width="40" height="40" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha">
    <path fill="#D9D9D9" d="M0 0h40v40H0z" />
  </mask>
  <g mask="url(#a)">
    <path
      fill="#737373"
      d="m30.392 32.749-4.714 4.714c-1.63 1.63-3.595 2.445-5.893 2.445-2.298 0-4.262-.815-5.892-2.445-1.63-1.63-2.446-3.595-2.446-5.893 0-2.298.815-4.262 2.446-5.892l4.714-4.714 2.357 2.357-4.714 4.714c-.982.982-1.474 2.16-1.474 3.535s.492 2.554 1.474 3.536c.982.982 2.16 1.473 3.535 1.473s2.554-.491 3.536-1.473l4.714-4.714 2.357 2.357Zm-8.25-1.179-2.357-2.357 9.428-9.428 2.357 2.357-9.428 9.428Zm10.607-1.178-2.357-2.357 4.714-4.714c.982-.983 1.473-2.161 1.473-3.536s-.491-2.553-1.473-3.535c-.982-.982-2.16-1.474-3.536-1.474-1.375 0-2.553.492-3.535 1.474l-4.714 4.714-2.357-2.357 4.714-4.714c1.63-1.63 3.594-2.446 5.892-2.446 2.298 0 4.263.815 5.893 2.446 1.63 1.63 2.445 3.594 2.445 5.892 0 2.298-.815 4.262-2.445 5.893l-4.714 4.714ZM10.085 18.93l-.279-2.229a2.637 2.637 0 0 1-.427-.209 5.709 5.709 0 0 1-.391-.26l-2.073.87L5 13.793l1.794-1.358a1.662 1.662 0 0 1-.018-.235v-.47c0-.075.006-.154.018-.235L5 10.137l1.915-3.309 2.073.871a4.75 4.75 0 0 1 .4-.261 3.8 3.8 0 0 1 .418-.21L10.085 5h3.83l.279 2.229c.15.058.293.128.427.209.133.081.264.168.391.261l2.073-.87L19 10.136l-1.794 1.358c.012.081.018.16.018.235v.47a.855.855 0 0 1-.035.235l1.794 1.358-1.916 3.309-2.055-.87a4.428 4.428 0 0 1-.818.47l-.279 2.228h-3.83Zm1.218-1.393h1.376l.244-1.845c.36-.093.694-.23 1.001-.41.308-.18.59-.397.845-.653l1.723.714.68-1.184-1.498-1.132c.058-.162.099-.333.122-.513a4.286 4.286 0 0 0 0-1.097 2.452 2.452 0 0 0-.122-.514l1.498-1.132-.68-1.184-1.723.731a3.867 3.867 0 0 0-.845-.67 3.903 3.903 0 0 0-1.001-.41l-.226-1.845H11.32l-.244 1.846a3.93 3.93 0 0 0-1.001.409 4.16 4.16 0 0 0-.845.653l-1.724-.714-.679 1.184 1.498 1.115a2.833 2.833 0 0 0-.122.522 4.22 4.22 0 0 0 0 1.097c.023.174.064.348.122.522L6.828 14.16l.68 1.184 1.723-.731a3.876 3.876 0 0 0 1.846 1.08l.226 1.845Zm.732-3.134c.673 0 1.248-.238 1.724-.714s.714-1.05.714-1.724a2.35 2.35 0 0 0-.714-1.724 2.349 2.349 0 0 0-1.724-.714c-.685 0-1.263.238-1.733.714a2.364 2.364 0 0 0-.705 1.724c0 .674.235 1.248.705 1.724s1.048.714 1.733.714Z"
    />
  </g>
</svg> `;
export const copyIcon = html `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12 23.9998C11.2667 23.9998 10.6389 23.7387 10.1167 23.2165C9.59444 22.6943 9.33333 22.0665 9.33333 21.3332V5.33317C9.33333 4.59984 9.59444 3.97206 10.1167 3.44984C10.6389 2.92762 11.2667 2.6665 12 2.6665H24C24.7333 2.6665 25.3611 2.92762 25.8833 3.44984C26.4056 3.97206 26.6667 4.59984 26.6667 5.33317V21.3332C26.6667 22.0665 26.4056 22.6943 25.8833 23.2165C25.3611 23.7387 24.7333 23.9998 24 23.9998H12ZM12 21.3332H24V5.33317H12V21.3332ZM6.66667 29.3332C5.93333 29.3332 5.30556 29.0721 4.78333 28.5498C4.26111 28.0276 4 27.3998 4 26.6665V7.99984H6.66667V26.6665H21.3333V29.3332H6.66667Z"
  />
</svg> `;
// ==============================
// NEW
// ==============================
export const homeIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 10.5651C3 9.9907 3 9.70352 3.07403 9.43905C3.1396 9.20478 3.24737 8.98444 3.39203 8.78886C3.55534 8.56806 3.78202 8.39175 4.23539 8.03912L11.0177 2.764C11.369 2.49075 11.5447 2.35412 11.7387 2.3016C11.9098 2.25526 12.0902 2.25526 12.2613 2.3016C12.4553 2.35412 12.631 2.49075 12.9823 2.764L19.7646 8.03913C20.218 8.39175 20.4447 8.56806 20.608 8.78886C20.7526 8.98444 20.8604 9.20478 20.926 9.43905C21 9.70352 21 9.9907 21 10.5651V17.8C21 18.9201 21 19.4801 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4801 3 18.9201 3 17.8V10.5651Z" stroke="#7F56D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
export const decksIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 15H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z" stroke="#7F56D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const uploadIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const xCircle = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const uploadCloud = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const google = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.5015 12.2332C22.5015 11.3699 22.43 10.7399 22.2753 10.0865H12.2158V13.9832H18.1205C18.0015 14.9515 17.3587 16.4099 15.9301 17.3898L15.91 17.5203L19.0907 19.935L19.311 19.9565C21.3348 18.1249 22.5015 15.4298 22.5015 12.2332" fill="white"/>
<path d="M12.215 22.5C15.1078 22.5 17.5363 21.5666 19.3102 19.9566L15.9292 17.3898C15.0245 18.0082 13.8102 18.4399 12.215 18.4399C9.38167 18.4399 6.97693 16.6082 6.11971 14.0765L5.99406 14.087L2.68681 16.5954L2.64355 16.7132C4.40543 20.1432 8.02448 22.5 12.215 22.5Z" fill="white"/>
<path d="M6.11997 14.0766C5.89379 13.4233 5.76289 12.7232 5.76289 11.9999C5.76289 11.2765 5.89379 10.5766 6.10807 9.92325L6.10208 9.78411L2.75337 7.23547L2.64381 7.28655C1.91765 8.7099 1.50098 10.3083 1.50098 11.9999C1.50098 13.6916 1.91765 15.2899 2.64381 16.7132L6.11997 14.0766" fill="white"/>
<path d="M12.215 5.55997C14.2269 5.55997 15.584 6.41163 16.3579 7.12335L19.3817 4.23C17.5246 2.53834 15.1078 1.5 12.215 1.5C8.02451 1.5 4.40544 3.85665 2.64355 7.28662L6.10783 9.92332C6.97696 7.39166 9.38171 5.55997 12.215 5.55997" fill="white"/>
</svg>
`;
export const addFolder = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17V11M9 14H15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const addFile = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M18 21V15M15 18H21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const home = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 17H16M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const rightChevron = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 18L15 12L9 6" stroke="#D5D7DA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const rightChevronBlack = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 18L15 12L9 6" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const folderIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z" stroke="#7F56D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const dotsVertical = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#7F56D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#7F56D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#7F56D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const copy = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const folderBlack = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const link = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9M15 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15M7 12L17 12" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const share = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 12V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M16 7L12 3M12 3L8 7M12 3V15" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const trashNew = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const newTab = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const users = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const pencil = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.87604 18.1157C2.92198 17.7022 2.94496 17.4955 3.00751 17.3022C3.06301 17.1308 3.14143 16.9676 3.24064 16.8172C3.35246 16.6476 3.49955 16.5005 3.79373 16.2063L17 3.00006C18.1046 1.89549 19.8955 1.89549 21 3.00006C22.1046 4.10463 22.1046 5.89549 21 7.00006L7.79373 20.2063C7.49955 20.5005 7.35245 20.6476 7.18289 20.7594C7.03245 20.8586 6.86929 20.937 6.69785 20.9925C6.5046 21.0551 6.29786 21.0781 5.88437 21.124L2.5 21.5001L2.87604 18.1157Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const bell = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.35395 21C10.0591 21.6224 10.9853 22 11.9998 22C13.0142 22 13.9405 21.6224 14.6456 21M17.9998 8C17.9998 6.4087 17.3676 4.88258 16.2424 3.75736C15.1172 2.63214 13.5911 2 11.9998 2C10.4085 2 8.88235 2.63214 7.75713 3.75736C6.63192 4.88258 5.99977 6.4087 5.99977 8C5.99977 11.0902 5.22024 13.206 4.34944 14.6054C3.6149 15.7859 3.24763 16.3761 3.2611 16.5408C3.27601 16.7231 3.31463 16.7926 3.46155 16.9016C3.59423 17 4.19237 17 5.38863 17H18.6109C19.8072 17 20.4053 17 20.538 16.9016C20.6849 16.7926 20.7235 16.7231 20.7384 16.5408C20.7519 16.3761 20.3846 15.7859 19.6501 14.6054C18.7793 13.206 17.9998 11.0902 17.9998 8Z" stroke="#9E77ED" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const groupsIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z" stroke="#7F56D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const plus = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 5V19M5 12H19" stroke="#7F56D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const addUser = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const leftChevron = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 18L9 12L15 6" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const singleUser = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const friends = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const logout = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 17L21 12M21 12L16 7M21 12H9M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const copyToSelf = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5 2.0028C9.82495 2.01194 9.4197 2.05103 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8.05103 3.4197 8.01194 3.82495 8.0028 4.5M19.5 2.0028C20.1751 2.01194 20.5803 2.05103 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C21.949 3.4197 21.9881 3.82494 21.9972 4.49999M21.9972 13.5C21.9881 14.175 21.949 14.5803 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.5803 15.949 20.1751 15.9881 19.5 15.9972M22 7.99999V9.99999M14.0001 2H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const leftArrow = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const addFolderBlack = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17V11M9 14H15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const cursorTool = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.40707 3.41379C3.94882 3.27901 3.7197 3.21162 3.56369 3.26977C3.42774 3.32045 3.32051 3.42768 3.26983 3.56363C3.21168 3.71963 3.27907 3.94876 3.41385 4.40701L7.61975 18.7071C7.74499 19.1329 7.80762 19.3458 7.93401 19.4447C8.0443 19.5309 8.1857 19.567 8.32383 19.5441C8.48212 19.5178 8.63906 19.3609 8.95292 19.047L12 15.9999L16.4343 20.4343C16.6323 20.6323 16.7313 20.7313 16.8455 20.7684C16.9459 20.801 17.0541 20.801 17.1545 20.7684C17.2687 20.7313 17.3677 20.6323 17.5657 20.4343L20.4343 17.5656C20.6323 17.3676 20.7313 17.2686 20.7684 17.1545C20.8011 17.054 20.8011 16.9459 20.7684 16.8454C20.7313 16.7313 20.6323 16.6323 20.4343 16.4343L16 11.9999L19.0471 8.95286C19.3609 8.63899 19.5179 8.48206 19.5441 8.32377C19.567 8.18564 19.531 8.04424 19.4447 7.93395C19.3459 7.80756 19.133 7.74493 18.7071 7.61969L4.40707 3.41379Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const pencilTool = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.49997 21.5001L8.04924 19.3657C8.40418 19.2292 8.58165 19.161 8.74769 19.0718C8.89517 18.9927 9.03577 18.9013 9.16801 18.7987C9.31689 18.6831 9.45134 18.5487 9.72025 18.2798L21 7.00006C22.1046 5.89549 22.1046 4.10463 21 3.00006C19.8954 1.89549 18.1046 1.89549 17 3.00006L5.72025 14.2798C5.45135 14.5487 5.31689 14.6831 5.20136 14.832C5.09874 14.9643 5.00737 15.1049 4.9282 15.2523C4.83908 15.4184 4.77082 15.5959 4.6343 15.9508L2.49997 21.5001ZM2.49997 21.5001L4.55809 16.149C4.70537 15.7661 4.779 15.5746 4.90531 15.4869C5.01569 15.4103 5.15227 15.3813 5.28427 15.4065C5.4353 15.4354 5.58035 15.5804 5.87045 15.8705L8.12954 18.1296C8.41964 18.4197 8.56469 18.5648 8.59353 18.7158C8.61874 18.8478 8.58976 18.9844 8.51311 19.0947C8.42542 19.2211 8.23396 19.2947 7.85104 19.442L2.49997 21.5001Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const eraserTool = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.9995 13L10.9995 6.00004M20.9995 21H7.99955M10.9368 20.0628L19.6054 11.3941C20.7935 10.2061 21.3875 9.61207 21.6101 8.92709C21.8058 8.32456 21.8058 7.67551 21.6101 7.07298C21.3875 6.388 20.7935 5.79397 19.6054 4.60592L19.3937 4.39415C18.2056 3.2061 17.6116 2.61207 16.9266 2.38951C16.3241 2.19373 15.675 2.19373 15.0725 2.38951C14.3875 2.61207 13.7935 3.2061 12.6054 4.39415L4.39366 12.6059C3.20561 13.794 2.61158 14.388 2.38902 15.073C2.19324 15.6755 2.19324 16.3246 2.38902 16.9271C2.61158 17.6121 3.20561 18.2061 4.39366 19.3941L5.06229 20.0628C5.40819 20.4087 5.58114 20.5816 5.78298 20.7053C5.96192 20.815 6.15701 20.8958 6.36108 20.9448C6.59126 21 6.83585 21 7.32503 21H8.67406C9.16324 21 9.40784 21 9.63801 20.9448C9.84208 20.8958 10.0372 20.815 10.2161 20.7053C10.418 20.5816 10.5909 20.4087 10.9368 20.0628Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const paintTool = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.9997 11L1.9997 11M9.9997 4L7.9997 2M13.9997 22L1.9997 22M21.9997 16C21.9997 17.1046 21.1043 18 19.9997 18C18.8951 18 17.9997 17.1046 17.9997 16C17.9997 14.8954 19.9997 13 19.9997 13C19.9997 13 21.9997 14.8954 21.9997 16ZM8.9997 3L15.8683 9.86863C16.2643 10.2646 16.4624 10.4627 16.5365 10.691C16.6018 10.8918 16.6018 11.1082 16.5365 11.309C16.4624 11.5373 16.2643 11.7354 15.8683 12.1314L11.2624 16.7373C10.4704 17.5293 10.0744 17.9253 9.61773 18.0737C9.21605 18.2042 8.78335 18.2042 8.38166 18.0737C7.92501 17.9253 7.52899 17.5293 6.73696 16.7373L3.26244 13.2627C2.4704 12.4707 2.07439 12.0747 1.92601 11.618C1.7955 11.2163 1.7955 10.7837 1.92601 10.382C2.07439 9.92531 2.47041 9.52929 3.26244 8.73726L8.9997 3Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const shapeTool = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const textualTool = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M9 20H15M12 4V20" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const addMediaTool = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M19 8V2M16 5H22M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const stars = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5 8V3M5.5 21V16M16 5.5H21M3 18.5H8M6.5 2L5.71554 3.56892C5.45005 4.09989 5.31731 4.36538 5.13997 4.59545C4.98261 4.79959 4.79959 4.98261 4.59545 5.13997C4.36538 5.31731 4.0999 5.45005 3.56892 5.71554L2 6.5L3.56892 7.28446C4.0999 7.54995 4.36538 7.68269 4.59545 7.86003C4.79959 8.01739 4.98261 8.20041 5.13997 8.40455C5.31731 8.63462 5.45005 8.9001 5.71554 9.43108L6.5 11L7.28446 9.43108C7.54995 8.9001 7.68269 8.63462 7.86003 8.40455C8.01739 8.20041 8.20041 8.01739 8.40455 7.86003C8.63462 7.68269 8.9001 7.54995 9.43108 7.28446L11 6.5L9.43108 5.71554C8.9001 5.45005 8.63462 5.31731 8.40455 5.13997C8.20041 4.98261 8.01739 4.79959 7.86003 4.59545C7.68269 4.36538 7.54995 4.0999 7.28446 3.56892L6.5 2ZM17 12L16.0489 13.9022C15.7834 14.4332 15.6506 14.6987 15.4733 14.9288C15.3159 15.1329 15.1329 15.3159 14.9288 15.4733C14.6987 15.6506 14.4332 15.7834 13.9023 16.0489L12 17L13.9023 17.9511C14.4332 18.2166 14.6987 18.3494 14.9288 18.5267C15.1329 18.6841 15.3159 18.8671 15.4733 19.0712C15.6506 19.3013 15.7834 19.5668 16.0489 20.0977L17 22L17.9511 20.0978C18.2166 19.5668 18.3494 19.3013 18.5267 19.0712C18.6841 18.8671 18.8671 18.6841 19.0712 18.5267C19.3013 18.3494 19.5668 18.2166 20.0977 17.9511L22 17L20.0977 16.0489C19.5668 15.7834 19.3013 15.6506 19.0712 15.4733C18.8671 15.3159 18.6841 15.1329 18.5267 14.9288C18.3494 14.6987 18.2166 14.4332 17.9511 13.9023L17 12Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const reverseRight = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 7H10C6.68629 7 4 9.68629 4 13C4 16.3137 6.68629 19 10 19H20M20 7L16 3M20 7L16 11" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const reverseLeft = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 7H14C17.3137 7 20 9.68629 20 13C20 16.3137 17.3137 19 14 19H4M4 7L8 3M4 7L8 11" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
export const saveFloppy = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 3V6.4C7 6.96005 7 7.24008 7.10899 7.45399C7.20487 7.64215 7.35785 7.79513 7.54601 7.89101C7.75992 8 8.03995 8 8.6 8H15.4C15.9601 8 16.2401 8 16.454 7.89101C16.6422 7.79513 16.7951 7.64215 16.891 7.45399C17 7.24008 17 6.96005 17 6.4V4M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const fullscreenExpand = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 8L21 3M21 3H16M21 3V8M8 8L3 3M3 3L3 8M3 3L8 3M8 16L3 21M3 21H8M3 21L3 16M16 16L21 21M21 21V16M21 21H16" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const supportChatIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 8.00224C10.1762 7.50136 10.524 7.07901 10.9817 6.80998C11.4395 6.54095 11.9777 6.4426 12.501 6.53237C13.0243 6.62213 13.499 6.89421 13.8409 7.30041C14.1829 7.70661 14.37 8.22072 14.3692 8.75168C14.3692 10.2506 12.1209 11 12.1209 11M12.1499 14H12.1599M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const greenCheckmark = html `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="20" height="20" rx="10" fill="#079455"/>
<path d="M6.25 10L8.75 12.5L13.75 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const addCard = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 8V16M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const minimapIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 18L2 22V6L9 2M9 18L16 22M9 18V2M16 22L22 18V2L16 6M16 22V6M16 6L9 2" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const rightArrow = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const maximize = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M8 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V16M21 8V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H16M21 16V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H16" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const lockAction = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 10V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V10M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const dotsHorizontal = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const duplicateIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const unlockIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 10V8C7 5.23858 9.23858 3 12 3C14.0503 3 15.8124 4.2341 16.584 6M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const addLinkQuickAction = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.7076 18.3639L11.2933 19.7781C9.34072 21.7308 6.1749 21.7308 4.22228 19.7781C2.26966 17.8255 2.26966 14.6597 4.22228 12.7071L5.63649 11.2929M18.3644 12.7071L19.7786 11.2929C21.7312 9.34024 21.7312 6.17441 19.7786 4.22179C17.826 2.26917 14.6602 2.26917 12.7076 4.22179L11.2933 5.636M8.50045 15.4999L15.5005 8.49994" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const copyQuickActionIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5 2.0028C9.82495 2.01194 9.4197 2.05103 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8.05103 3.4197 8.01194 3.82495 8.0028 4.5M19.5 2.0028C20.1751 2.01194 20.5803 2.05103 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C21.949 3.4197 21.9881 3.82494 21.9972 4.49999M21.9972 13.5C21.9881 14.175 21.949 14.5803 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.5803 15.949 20.1751 15.9881 19.5 15.9972M22 7.99999V9.99999M14.0001 2H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const groupQuickAction = html `<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 5.5H6.83333C6.36662 5.5 6.13327 5.5 5.95501 5.59083C5.79821 5.67072 5.67072 5.79821 5.59083 5.95501C5.5 6.13327 5.5 6.36662 5.5 6.83333V10C5.5 10.4667 5.5 10.7001 5.59083 10.8783C5.67072 11.0351 5.79821 11.1626 5.95501 11.2425C6.13327 11.3333 6.36662 11.3333 6.83333 11.3333H10C10.4667 11.3333 10.7001 11.3333 10.8783 11.2425C11.0351 11.1626 11.1626 11.0351 11.2425 10.8783C11.3333 10.7001 11.3333 10.4667 11.3333 10V6.83333C11.3333 6.36662 11.3333 6.13327 11.2425 5.95501C11.1626 5.79821 11.0351 5.67072 10.8783 5.59083C10.7001 5.5 10.4667 5.5 10 5.5Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.1667 5.5H16C15.5333 5.5 15.2999 5.5 15.1217 5.59083C14.9649 5.67072 14.8374 5.79821 14.7575 5.95501C14.6667 6.13327 14.6667 6.36662 14.6667 6.83333V10C14.6667 10.4667 14.6667 10.7001 14.7575 10.8783C14.8374 11.0351 14.9649 11.1626 15.1217 11.2425C15.2999 11.3333 15.5333 11.3333 16 11.3333H19.1667C19.6334 11.3333 19.8667 11.3333 20.045 11.2425C20.2018 11.1626 20.3293 11.0351 20.4092 10.8783C20.5 10.7001 20.5 10.4667 20.5 10V6.83333C20.5 6.36662 20.5 6.13327 20.4092 5.95501C20.3293 5.79821 20.2018 5.67072 20.045 5.59083C19.8667 5.5 19.6334 5.5 19.1667 5.5Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.1667 14.6667H16C15.5333 14.6667 15.2999 14.6667 15.1217 14.7575C14.9649 14.8374 14.8374 14.9649 14.7575 15.1217C14.6667 15.2999 14.6667 15.5333 14.6667 16V19.1667C14.6667 19.6334 14.6667 19.8667 14.7575 20.045C14.8374 20.2018 14.9649 20.3293 15.1217 20.4092C15.2999 20.5 15.5333 20.5 16 20.5H19.1667C19.6334 20.5 19.8667 20.5 20.045 20.4092C20.2018 20.3293 20.3293 20.2018 20.4092 20.045C20.5 19.8667 20.5 19.6334 20.5 19.1667V16C20.5 15.5333 20.5 15.2999 20.4092 15.1217C20.3293 14.9649 20.2018 14.8374 20.045 14.7575C19.8667 14.6667 19.6334 14.6667 19.1667 14.6667Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 14.6667H6.83333C6.36662 14.6667 6.13327 14.6667 5.95501 14.7575C5.79821 14.8374 5.67072 14.9649 5.59083 15.1217C5.5 15.2999 5.5 15.5333 5.5 16V19.1667C5.5 19.6334 5.5 19.8667 5.59083 20.045C5.67072 20.2018 5.79821 20.3293 5.95501 20.4092C6.13327 20.5 6.36662 20.5 6.83333 20.5H10C10.4667 20.5 10.7001 20.5 10.8783 20.4092C11.0351 20.3293 11.1626 20.2018 11.2425 20.045C11.3333 19.8667 11.3333 19.6334 11.3333 19.1667V16C11.3333 15.5333 11.3333 15.2999 11.2425 15.1217C11.1626 14.9649 11.0351 14.8374 10.8783 14.7575C10.7001 14.6667 10.4667 14.6667 10 14.6667Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.75 7.75C1.75 5.6498 1.75 4.5997 2.15873 3.79754C2.51825 3.09193 3.09193 2.51825 3.79754 2.15873C4.5997 1.75 5.6498 1.75 7.75 1.75H18.25C20.3502 1.75 21.4003 1.75 22.2025 2.15873C22.9081 2.51825 23.4817 3.09193 23.8413 3.79754C24.25 4.5997 24.25 5.6498 24.25 7.75V18.25C24.25 20.3502 24.25 21.4003 23.8413 22.2025C23.4817 22.9081 22.9081 23.4817 22.2025 23.8413C21.4003 24.25 20.3502 24.25 18.25 24.25H7.75C5.6498 24.25 4.5997 24.25 3.79754 23.8413C3.09193 23.4817 2.51825 22.9081 2.15873 22.2025C1.75 21.4003 1.75 20.3502 1.75 18.25V7.75Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const ungroupQuickAction = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const moveForwardQuickAction = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 12.8C16 13.9201 16 14.4802 15.782 14.908C15.5903 15.2843 15.2843 15.5903 14.908 15.782C14.4802 16 13.9201 16 12.8 16H8V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16V9V12.8Z" fill="#414651"/>
<path d="M15.782 14.908C16 14.4802 16 13.9201 16 12.8V9V8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V16H12.8C13.9201 16 14.4802 16 14.908 15.782C15.2843 15.5903 15.5903 15.2843 15.782 14.908Z" fill="#414651"/>
<path d="M8 16H12.8C13.9201 16 14.4802 16 14.908 15.782C15.2843 15.5903 15.5903 15.2843 15.782 14.908C16 14.4802 16 13.9201 16 12.8V9V8M8 16V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16M8 16V11.2C8 10.0799 8 9.51984 8.21799 9.09202C8.40973 8.71569 8.71569 8.40973 9.09202 8.21799C9.51984 8 10.0799 8 11.2 8H16M8 16H5.2C4.07989 16 3.51984 16 3.09202 15.782C2.71569 15.5903 2.40973 15.2843 2.21799 14.908C2 14.4802 2 13.9201 2 12.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H12.8C13.9201 2 14.4802 2 14.908 2.21799C15.2843 2.40973 15.5903 2.71569 15.782 3.09202C16 3.51984 16 4.0799 16 5.2V8" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const moveBackwardQuickAction = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.07989 16 5.2 16H8V11.2C8 10.0799 8 9.51984 8.21799 9.09202C8.40973 8.71569 8.71569 8.40973 9.09202 8.21799C9.51984 8 10.0799 8 11.2 8H16V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2Z" fill="#414651"/>
<path d="M8 16H5.2C4.07989 16 3.51984 16 3.09202 15.782C2.71569 15.5903 2.40973 15.2843 2.21799 14.908C2 14.4802 2 13.9201 2 12.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H12.8C13.9201 2 14.4802 2 14.908 2.21799C15.2843 2.40973 15.5903 2.71569 15.782 3.09202C16 3.51984 16 4.0799 16 5.2V8M8 16V11.2C8 10.0799 8 9.51984 8.21799 9.09202C8.40973 8.71569 8.71569 8.40973 9.09202 8.21799C9.51984 8 10.0799 8 11.2 8H16M8 16V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const highlighterToolbar = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 20.9998H13M2.5 21.4998L8.04927 19.3655C8.40421 19.229 8.58168 19.1607 8.74772 19.0716C8.8952 18.9924 9.0358 18.901 9.16804 18.7984C9.31692 18.6829 9.45137 18.5484 9.72028 18.2795L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L5.72028 14.2795C5.45138 14.5484 5.31692 14.6829 5.20139 14.8318C5.09877 14.964 5.0074 15.1046 4.92823 15.2521C4.83911 15.4181 4.77085 15.5956 4.63433 15.9506L2.5 21.4998ZM2.5 21.4998L4.55812 16.1488C4.7054 15.7659 4.77903 15.5744 4.90534 15.4867C5.01572 15.4101 5.1523 15.3811 5.2843 15.4063C5.43533 15.4351 5.58038 15.5802 5.87048 15.8703L8.12957 18.1294C8.41967 18.4195 8.56472 18.5645 8.59356 18.7155C8.61877 18.8475 8.58979 18.9841 8.51314 19.0945C8.42545 19.2208 8.23399 19.2944 7.85107 19.4417L2.5 21.4998Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const dotsGrabbable = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const circleShape = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const squareShape = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const triangleShape = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.39019 18.0983L10.6151 3.89171C11.0696 3.10655 11.2969 2.71396 11.5935 2.58211C11.8521 2.4671 12.1474 2.4671 12.4061 2.58211C12.7026 2.71396 12.9299 3.10654 13.3844 3.89171L21.6093 18.0983C22.0655 18.8863 22.2936 19.2803 22.2599 19.6037C22.2305 19.8857 22.0827 20.142 21.8534 20.3088C21.5904 20.5 21.1352 20.5 20.2246 20.5H3.77487C2.86435 20.5 2.40908 20.5 2.14613 20.3088C1.91677 20.142 1.769 19.8857 1.73959 19.6037C1.70588 19.2803 1.93398 18.8863 2.39019 18.0983Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const pentagonShape = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.0605 2.93203C11.3983 2.68689 11.5672 2.56432 11.7518 2.51696C11.9148 2.47514 12.0858 2.47514 12.2488 2.51696C12.4334 2.56432 12.6023 2.68689 12.9401 2.93203L21.0586 8.82396C21.397 9.06956 21.5663 9.19235 21.6686 9.3535C21.7589 9.49579 21.8119 9.65862 21.8224 9.82684C21.8344 10.0174 21.7697 10.2162 21.6404 10.6138L18.5401 20.1449C18.4109 20.5421 18.3463 20.7407 18.2247 20.8876C18.1173 21.0173 17.979 21.1178 17.8224 21.1798C17.6451 21.25 17.4362 21.25 17.0186 21.25H6.98203C6.56437 21.25 6.35554 21.25 6.17822 21.1798C6.02164 21.1178 5.88325 21.0173 5.77589 20.8876C5.65429 20.7407 5.58969 20.5421 5.4605 20.1449L2.36021 10.6138C2.23086 10.2162 2.16619 10.0174 2.17817 9.82684C2.18874 9.65862 2.24166 9.49579 2.33202 9.3535C2.43434 9.19235 2.60355 9.06956 2.94196 8.82396L11.0605 2.93203Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const hexagonShape = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7985 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42756 21 7.59889 21 7.94153V16.0586C21 16.4013 21 16.5726 20.9495 16.7254C20.9049 16.8606 20.8318 16.9847 20.7354 17.0893C20.6263 17.2077 20.4766 17.2909 20.177 17.4573L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7985 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52345 17.2909 3.37369 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42756 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37369 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const octogonShape = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.39137 2.46863C7.56432 2.29568 7.6508 2.2092 7.75172 2.14736C7.84119 2.09253 7.93873 2.05213 8.04077 2.02763C8.15586 2 8.27815 2 8.52274 2H15.4773C15.7218 2 15.8441 2 15.9592 2.02763C16.0613 2.05213 16.1588 2.09253 16.2483 2.14736C16.3492 2.2092 16.4357 2.29568 16.6086 2.46863L21.5314 7.39137C21.7043 7.56432 21.7908 7.6508 21.8526 7.75172C21.9075 7.84119 21.9479 7.93873 21.9724 8.04077C22 8.15586 22 8.27815 22 8.52274V15.4773C22 15.7218 22 15.8441 21.9724 15.9592C21.9479 16.0613 21.9075 16.1588 21.8526 16.2483C21.7908 16.3492 21.7043 16.4357 21.5314 16.6086L16.6086 21.5314C16.4357 21.7043 16.3492 21.7908 16.2483 21.8526C16.1588 21.9075 16.0613 21.9479 15.9592 21.9724C15.8441 22 15.7218 22 15.4773 22H8.52274C8.27815 22 8.15586 22 8.04077 21.9724C7.93873 21.9479 7.84119 21.9075 7.75172 21.8526C7.6508 21.7908 7.56432 21.7043 7.39137 21.5314L2.46863 16.6086C2.29568 16.4357 2.2092 16.3492 2.14736 16.2483C2.09253 16.1588 2.05213 16.0613 2.02763 15.9592C2 15.8441 2 15.7218 2 15.4773V8.52274C2 8.27815 2 8.15586 2.02763 8.04077C2.05213 7.93873 2.09253 7.84119 2.14736 7.75172C2.2092 7.6508 2.29568 7.56432 2.46863 7.39137L7.39137 2.46863Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const chevronUp = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 15L12 9L6 15" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const chevronDown = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 9L12 15L18 9" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const minusFont = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 12H19" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const plusFont = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 5V19M5 12H19" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const alignCenterIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 10H6M21 6H3M21 14H3M18 18H6" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const alignLeftIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 10H3M20 6H3M20 14H3M16 18H3" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const alignRightIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 10H8M21 6H4M21 14H4M21 18H8" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const alignBottomIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 21H21M12 3V17M12 17L19 10M12 17L5 10" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const alignVerticalCenterIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M12 2V8.5M12 8.5L16 4.5M12 8.5L8 4.5M12 22V15.5M12 15.5L16 19.5M12 15.5L8 19.5" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const alignTopIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 3H3M12 21V7M12 7L5 14M12 7L19 14" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const boldTextIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 12H14C16.2091 12 18 10.2091 18 8C18 5.79086 16.2091 4 14 4H6V12ZM6 12H15C17.2091 12 19 13.7909 19 16C19 18.2091 17.2091 20 15 20H6V12Z" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const underlineTextIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 4V11C18 14.3137 15.3137 17 12 17C8.68629 17 6 14.3137 6 11V4M4 21H20" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const italicTextIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 4H10M14 20H5M15 4L9 20" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const coloredGoogleIcon = html `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_22154_2644)">
<path d="M24.2663 12.2765C24.2663 11.4608 24.2001 10.6406 24.059 9.83813H12.7402V14.4591H19.222C18.953 15.9495 18.0888 17.2679 16.8233 18.1056V21.104H20.6903C22.9611 19.014 24.2663 15.9274 24.2663 12.2765Z" fill="#4285F4"/>
<path d="M12.74 24.0008C15.9764 24.0008 18.7058 22.9382 20.6944 21.1039L16.8274 18.1055C15.7516 18.8375 14.3626 19.252 12.7444 19.252C9.61376 19.252 6.95934 17.1399 6.00693 14.3003H2.01648V17.3912C4.05359 21.4434 8.20278 24.0008 12.74 24.0008Z" fill="#34A853"/>
<path d="M6.00277 14.3002C5.50011 12.8099 5.50011 11.196 6.00277 9.70569V6.61475H2.01674C0.314734 10.0055 0.314734 14.0004 2.01674 17.3912L6.00277 14.3002Z" fill="#FBBC04"/>
<path d="M12.74 4.74966C14.4508 4.7232 16.1043 5.36697 17.3433 6.54867L20.7694 3.12262C18.6 1.0855 15.7207 -0.034466 12.74 0.000808666C8.20277 0.000808666 4.05359 2.55822 2.01648 6.61481L6.00252 9.70575C6.95052 6.86173 9.60935 4.74966 12.74 4.74966Z" fill="#EA4335"/>
</g>
<defs>
<clipPath id="clip0_22154_2644">
<rect width="24" height="24" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>
`;
export const radialThingy = html `<svg width="768" height="584" viewBox="0 0 768 584" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="768" height="768" transform="translate(0 -184)" fill="url(#paint0_radial_22154_2541)"/>
<defs>
<radialGradient id="paint0_radial_22154_2541" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(384 384) rotate(90) scale(384 384)">
<stop/>
<stop offset="1" stop-opacity="0"/>
</radialGradient>
</defs>
</svg>
`;
export const backgroundPatternDecorative = html `<svg width="768" height="584" viewBox="0 0 768 584" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_22154_2539" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="-184" width="768" height="768">
<rect width="768" height="768" transform="translate(0 -184)" fill="url(#paint0_radial_22154_2539)"/>
</mask>
<g mask="url(#mask0_22154_2539)">
<g clip-path="url(#clip0_22154_2539)">
<g clip-path="url(#clip1_22154_2539)">
<line x1="0.5" y1="-184" x2="0.5" y2="584" stroke="#E9EAEB"/>
<line x1="48.5" y1="-184" x2="48.5" y2="584" stroke="#E9EAEB"/>
<line x1="96.5" y1="-184" x2="96.5" y2="584" stroke="#E9EAEB"/>
<line x1="144.5" y1="-184" x2="144.5" y2="584" stroke="#E9EAEB"/>
<line x1="192.5" y1="-184" x2="192.5" y2="584" stroke="#E9EAEB"/>
<line x1="240.5" y1="-184" x2="240.5" y2="584" stroke="#E9EAEB"/>
<line x1="288.5" y1="-184" x2="288.5" y2="584" stroke="#E9EAEB"/>
<line x1="336.5" y1="-184" x2="336.5" y2="584" stroke="#E9EAEB"/>
<line x1="384.5" y1="-184" x2="384.5" y2="584" stroke="#E9EAEB"/>
<line x1="432.5" y1="-184" x2="432.5" y2="584" stroke="#E9EAEB"/>
<line x1="480.5" y1="-184" x2="480.5" y2="584" stroke="#E9EAEB"/>
<line x1="528.5" y1="-184" x2="528.5" y2="584" stroke="#E9EAEB"/>
<line x1="576.5" y1="-184" x2="576.5" y2="584" stroke="#E9EAEB"/>
<line x1="624.5" y1="-184" x2="624.5" y2="584" stroke="#E9EAEB"/>
<line x1="672.5" y1="-184" x2="672.5" y2="584" stroke="#E9EAEB"/>
<line x1="720.5" y1="-184" x2="720.5" y2="584" stroke="#E9EAEB"/>
</g>
<rect x="0.5" y="-183.5" width="767" height="767" stroke="#E9EAEB"/>
<g clip-path="url(#clip2_22154_2539)">
<line y1="7.5" x2="768" y2="7.5" stroke="#E9EAEB"/>
<line y1="55.5" x2="768" y2="55.5" stroke="#E9EAEB"/>
<line y1="103.5" x2="768" y2="103.5" stroke="#E9EAEB"/>
<line y1="151.5" x2="768" y2="151.5" stroke="#E9EAEB"/>
<line y1="199.5" x2="768" y2="199.5" stroke="#E9EAEB"/>
<line y1="247.5" x2="768" y2="247.5" stroke="#E9EAEB"/>
<line y1="295.5" x2="768" y2="295.5" stroke="#E9EAEB"/>
<line y1="343.5" x2="768" y2="343.5" stroke="#E9EAEB"/>
<line y1="391.5" x2="768" y2="391.5" stroke="#E9EAEB"/>
<line y1="439.5" x2="768" y2="439.5" stroke="#E9EAEB"/>
<line y1="487.5" x2="768" y2="487.5" stroke="#E9EAEB"/>
<line y1="535.5" x2="768" y2="535.5" stroke="#E9EAEB"/>
<line y1="583.5" x2="768" y2="583.5" stroke="#E9EAEB"/>
</g>
<rect x="0.5" y="-183.5" width="767" height="767" stroke="#E9EAEB"/>
</g>
</g>
<defs>
<radialGradient id="paint0_radial_22154_2539" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(384 384) rotate(90) scale(384 384)">
<stop/>
<stop offset="1" stop-opacity="0"/>
</radialGradient>
<clipPath id="clip0_22154_2539">
<rect width="768" height="768" fill="white" transform="translate(0 -184)"/>
</clipPath>
<clipPath id="clip1_22154_2539">
<rect y="-184" width="768" height="768" fill="white"/>
</clipPath>
<clipPath id="clip2_22154_2539">
<rect y="-184" width="768" height="768" fill="white"/>
</clipPath>
</defs>
</svg>
`;
export const loadingSpinner = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2.25V4.75M12 18V22M5.75 12H2.25M21.25 12H19.75M18.4571 18.4571L17.75 17.75M18.6642 5.41579L17.25 6.83M4.92157 19.0784L7.75 16.25M5.12868 5.20868L7.25 7.33" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const exitIcon = html `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 7L7 17M7 7L17 17" stroke="#414651" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
